import {
	OP_Container,
	OR_BlockText,
	OR_Description,
	OR_Icon,
	OR_LeftBlock,
	OR_RightBlock,
	OR_TextBlock,
	OR_Title,
} from "../OrderPages.styled";
import { IconThankYou } from "../../../components/common/Icons";
import { Button } from "../../../components/common";
import { ButtonSize, PaymentVerifyStatus } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { useEffect } from "react";

interface OrderSuccessPageProps {}

export const OrderSuccessPage = observer(({}: OrderSuccessPageProps) => {
	const { authStore, paymentStore } = useStores();

	const navigate = useNavigate();
	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		void paymentStore.verifyOrderSuccess(searchParams, authStore);

		return () => {
			paymentStore.reset();
		};
	}, []);

	const handleOnToSubscriptions = () => {
		navigate("/cabinet/my-subscriptions");
	};

	const handleOnToPricing = () => {
		navigate("/cabinet/subscriptions-plans");
	};

	if (paymentStore.verifyStatus === PaymentVerifyStatus.Verifying) {
		return (
			<OP_Container>
				<OR_LeftBlock>
					<OR_TextBlock>
						<OR_Title>Checking payment</OR_Title>
						<OR_Description>Please wait, we are verifying your order.</OR_Description>
					</OR_TextBlock>
				</OR_LeftBlock>
			</OP_Container>
		);
	}

	if (paymentStore.verifyStatus === PaymentVerifyStatus.Failed) {
		return (
			<OP_Container>
				<OR_LeftBlock>
					<OR_TextBlock>
						<OR_Title>Payment verification failed</OR_Title>
						<OR_Description>We could not confirm your payment. Please try again or contact support.</OR_Description>
					</OR_TextBlock>
				</OR_LeftBlock>
				<OR_RightBlock>
					<Button size={ButtonSize.SMALL} onClick={handleOnToPricing}>
						Back to Pricing
					</Button>
				</OR_RightBlock>
			</OP_Container>
		);
	}

	if (paymentStore.verifyStatus === PaymentVerifyStatus.Pending) {
		return (
			<OP_Container>
				<OR_LeftBlock>
					<OR_TextBlock>
						<OR_Title>Payment is processing</OR_Title>
						<OR_Description>Your payment was received, but the order is still being confirmed.</OR_Description>
					</OR_TextBlock>
				</OR_LeftBlock>
				<OR_RightBlock>
					<OR_BlockText>Please refresh this page in a few seconds or check your subscriptions later.</OR_BlockText>
					<Button size={ButtonSize.SMALL} onClick={() => window.location.reload()}>
						Check Again
					</Button>
				</OR_RightBlock>
			</OP_Container>
		);
	}

	return (
		<OP_Container>
			<OR_LeftBlock>
				<OR_Icon>
					<IconThankYou />
				</OR_Icon>

				<OR_TextBlock>
					<OR_Title>Thank you</OR_Title>
					<OR_Description>Your order was completed successfully.</OR_Description>
				</OR_TextBlock>
			</OR_LeftBlock>

			<OR_RightBlock>
				<OR_BlockText>
					An email receipt, including all details about your order, has been sent to the email address you provided.
					Please keep it your records.
				</OR_BlockText>

				<OR_BlockText>
					You can visit My Subscriptions page at any time to see your active subscriptions and products you’ve
					purchased.
				</OR_BlockText>

				<Button size={ButtonSize.SMALL} onClick={handleOnToSubscriptions}>
					Visit My Subscriptions
				</Button>
			</OR_RightBlock>
		</OP_Container>
	);
});
